import React, { useEffect } from "react";
import "./Admission.css";
import { LuChevronRight, LuDownload } from "react-icons/lu";
import ApplicationProcess from "../../Components/ApplicationProcess/ApplicationProcess";
import cloudimg from "../../Assets/Designs/cloudx2.png";
import { FaPhoneAlt } from "react-icons/fa";
import { FaEnvelope, FaLocationDot } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import {
  getAdmissionsPage,
  getContactPage,
  getProgramsPage,
} from "../../Redux/Slices/AppSlices";
import Loader from "../../Components/Loader/Loader";
import Form from "../../Components/Form/Form";

const Admission = () => {
  const dispatch = useDispatch();
  const { admissionsPage, programsPage, contactPage, loading } = useSelector(
    (state) => state.app,
  );

  useEffect(() => {
    dispatch(getAdmissionsPage());
    dispatch(getProgramsPage());
    dispatch(getContactPage());
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="admission-page">
      <div className=" landing-pages">
        <div className="Founder-box">
          {/* LEFT CONTENT */}
          <div className="Founder-left">
            <p className="founder-subtitle">{admissionsPage?.heroSubtitle}</p>
            <h2 className="founder-title">{admissionsPage?.heroTitle}</h2>
            <p className="founder-desc">{admissionsPage?.heroDescription}</p>

            <div className="admission-item-btn">
              <button className="btn-fill">
                {admissionsPage?.primaryButton}
                <LuChevronRight />
              </button>
              <button
                className="btn-outline"
                disabled={!admissionsPage?.brochure?.url}
                onClick={async () => {
                  try {
                    const response = await fetch(admissionsPage?.brochure?.url);
                    const blob = await response.blob();

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = admissionsPage?.brochure?.name || "file";
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                  } catch (err) {
                    console.error("Download failed", err);
                  }
                }}
              >
                Download Brochure <LuDownload />
              </button>
            </div>
          </div>

          <div className="Founder-right">
            <div className="image-blob">
              <img src={admissionsPage?.heroImage?.url} alt="admission" />
            </div>
          </div>
        </div>
      </div>
      <div className="landing-pages">
        <div className="Chooseus landing-pages">
          <h2>{admissionsPage?.eligibilityTitle}</h2>
          <p>{admissionsPage?.eligibilityDescription}</p>
          <div className="admission-age-box">
            {programsPage?.programs?.map((item, index) => (
              <div className="ageeligibility-card" key={item.id}>
                <h5>{item.program}</h5>
                <p>{item.ageRange} Years</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <ApplicationProcess
        title={admissionsPage?.applicationTitle}
        subtitle={admissionsPage?.applicationSubtitle}
        steps={admissionsPage?.applicationStep}
      />
      <div className=" landing-pages">
        {/* Required Documents */}
        <section className="admission-section">
          <div className="admission-section-box">
            <div className="admission-section-left">
              <img src={admissionsPage?.documentsImage?.url} alt="" />
            </div>
            <div className="admission-section-right">
              <p className="chooseus-subtitle">
                {admissionsPage?.documentsSubtitle}
              </p>
              <h2 className="chooseus-title">
                {admissionsPage?.documentsTitle}
              </h2>
              <ul>
                {admissionsPage?.documentList?.map((item, index) => (
                  <li key={index}>
                    <span>{index + 1}</span>

                    {item.item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        {/* Contact Information */}
        <section
          className="admission-section contact-box"
          style={{ backgroundImage: `${contactPage?.formImage?.url}` }}
        >
          <div className="contact-section-box">
            <div className="contact-section-left">
              <h2>{admissionsPage?.enquiryTitle}</h2>
              <Form />
            </div>
            <div className="contact-section-right">
              <div className="contact-section-item">
                <h2>Contact Information</h2>
                <div className="contact-item">
                  <FaPhoneAlt />
                  <div className="contact-item-detail">
                    <h5>Phone No.</h5>
                    <p>{contactPage?.phone}</p>
                  </div>
                </div>
                <div className="contact-item">
                  <FaEnvelope />
                  <div className="contact-item-detail">
                    <h5>Email</h5>
                    <p>{contactPage?.email}</p>
                  </div>
                </div>
                <div className="contact-item">
                  <FaLocationDot />
                  <div className="contact-item-detail">
                    <h5>Address</h5>
                    <p>{contactPage?.address}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Admission;
